<template>
  <div>
    <el-tabs type="border-card" class="result-tab"  v-if="isShowProInfo">
      <el-tab-pane :label="$t('T_PROJECTION_CONDITION')">
        <div class="position-container">
          <Resultinformation class="wrap__result_1" v-if="!isUSTWall" isCurved="true"></Resultinformation>
        </div>
      </el-tab-pane>

      <el-tab-pane :label="$t('T_CURVE_CURVED_CORRECTION')">
        <div class='setting-container' id="copy_text">
          <table  class='curved-result-table'>
            <tr class="correction-tr">
              <td>{{$t('T_CURVE_CURVED_CORRECTION')}}</td>
              <td class="curve-result">{{correctionResult}}</td>
              <td>
                <div>
                  <ul :class="{'curve-result-info': correctionResult==='NG' && focusResult === 'NG'}">
                    <li v-for="(item, index) in correctionInfo" :key='index'>
                      <span v-if="correctionResult==='NG'"><span v-if="item !=='T_CURVE_CURVED_CORRECTION_MSG' && item !=='T_MESSAGE_SURFACE_CORRECTION'">{{index}}.</span>{{$t(item)}}</span>
                      <span v-else>{{item.id}}</span>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr class="focus-tr">
              <td>{{$t('T_CURVE_FOCUS_RANGE')}}</td>
              <td class="curve-result">{{focusResult}}</td>
              <td>
                 <ul :class="{'curve-result-info': correctionResult==='NG' && focusResult === 'NG'}">
                  <li v-for="(item, index) in focusInfo" :key='index'>
                    <span v-if="focusResult==='NG'">{{$t(item.id)}}</span>
                    <span v-else>{{item.id}}</span>
                  </li>
                </ul>
              </td>
            </tr>
          </table>
          <div class="curved-result-span">
            {{$t('T_CURVE_DISCLAIMER_MSG_1')}}
            {{$t('T_CURVE_DISCLAIMER_MSG_2')}}
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div v-else>
      <div class="container-table-curved ">
        <table  class='curved-result-table-pdf result-font-size' >
        <tr class="correction-tr">
          <td style="width: 50px;">{{$t('T_CURVE_CURVED_CORRECTION')}}</td>
          <td style="width: 30px;" class="curve-result">{{correctionResult}}</td>
          <td>
            <div>
              <ul>
                <li v-for="(item, index) in correctionNGInfoMSG" :key='index'>
                  <span v-if="correctionResult==='NG'"><span v-if="item !=='T_CURVE_CURVED_CORRECTION_MSG' && item !=='T_MESSAGE_SURFACE_CORRECTION'">{{index}}.</span>{{$t(item)}}</span>
                  <span v-else>{{item.id}}</span>
                </li>
              </ul>
            </div>
          </td>
        </tr>
        <tr class="focus-tr">
          <td>{{$t('T_CURVE_FOCUS_RANGE')}}</td>
          <td class="curve-result">{{focusResult}}</td>
          <td>
              <ul :class="{'curve-result-info': correctionResult==='NG' && focusResult === 'NG'}">
              <li v-for="(item, index) in focusInfo" :key='index'>
                <span v-if="focusResult==='NG'">{{$t(item.id)}}</span>
                <span v-else>{{item.id}}</span>
              </li>
            </ul>
          </td>
        </tr>
      </table>
      </div>
      <div class="result-font-size" >
        {{$t('T_CURVE_DISCLAIMER_MSG_1')}}
        {{$t('T_CURVE_DISCLAIMER_MSG_2')}}
      </div>
    </div>

  </div>
</template>

<script>
import Resultinformation from '@/view/result/resultInformation'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'curvedResultInfomation',
  data () {
    return {
      // curvedCorrectionPJ: ['Luxembourg', 'Nepal', 'Nepal10', 'Nepal10-UG', 'Mongolia', 'Poland', 'Iceland', 'Iceland-UG'],
      curvedCorrectionPJ: [],
      R_L_condition: true,
      correctionResult: 'NG',
      focusResult: 'NG',
      correctionNGInfoArray: [
        'T_CURVE_CURVED_CORRECTION_MSG'
      ],
      focusNGInfoArray: [
        {id: 'T_CURVE_FOCUS_RANGE_MSG'},
        {id: 'T_CURVE_FOCUS_RANGE_MSG_1'},
        {id: 'T_CURVE_FOCUS_RANGE_MSG_2'}
      ]
    }
  },
  props: {
    isShowProInfo: {
      type: Boolean,
      default: false
    }
  },
  components: {Resultinformation},
  computed: {
    ...mapState([
      'graph',
      'houseInfo',
      'selectedModelData',
      'selectedLensData',
      'aspectRatio',
      'isUSTWall',
      'isOutOfSpec',
      'curveShape',
      'curveDirection',
      'curveRadius',
      'curveDepth',
      'drawData',
      'vAngle',
      'hAngle',
      'hLensShiftNow',
      'vLensShiftNow',
      'correctionNGInfoMSG'
    ]),
    correctionInfo () {
      return this.correctionResult === 'OK' ? this.checkOkMsg() : (this.curvedCorrectionPJ.indexOf(this.selectedModelData.modelSeries) === -1 ? this.checkIsProMsg() : this.checkNGMsg())
    },
    focusInfo () {
      return this.focusResult === 'OK' ? [{'id': 'OK'}] : this.focusNGInfoArray
    },
    isPJXYCenter () {
      // 水平曲面可上下拖动， 垂直曲面可左右拖动
      // curveShape '0':垂直曲面, '1':水平曲面, '2': 平面
      if (this.curveShape === '1') {
        return this.graph.pjX.toFixed(0) === (this.houseInfo.roomW / 2).toFixed(0)
      }
      if (this.curveShape === '0') {
        return this.graph.pjZ.toFixed(0) === (this.houseInfo.roomH / 2).toFixed(0)
      }
    }
  },
  watch: {
    drawData: {
      handler (newValue, oldValue) {
        this.calcCorrectionResult()
      },
      deep: true
    },
    curveDirection (newValue, oldValue) {
      this.calcCorrectionResult()
    }
  },
  methods: {
    calcCorrectionResult () {
      this.curvedCorrectionPJ = []
      this.ProjectorSpec.map((item) => {
        if (item.curvedCorrection && !this.curvedCorrectionPJ.includes(item.modelSeries)) {
          this.curvedCorrectionPJ.push(item.modelSeries)
        }
      })
      // 不属于可补正机种
      if (this.curvedCorrectionPJ.indexOf(this.selectedModelData.modelSeries) === -1) {
        this.correctionResult = 'NG'
        this.focusResult = 'NG'
        return
      }

      // 不在投影中心 或 有水平lensshift
      if (!this.isPJXYCenter || this.hLensShiftNow) {
        this.correctionResult = 'NG'
        this.focusResult = 'NG'
        return
      }

      // 設置角度が0度以外の場合は、”NG”と表示する
      if (this.vAngle || this.hAngle) {
        this.correctionResult = 'NG'
        this.focusResult = 'NG'
        return
      }
      let curveScreenH = this.graph.scrnH
      let curveScreenW = this.graph.scrnW
      let curveScreenSize = (Math.sqrt(Math.pow(curveScreenH, 2) + Math.pow(curveScreenW, 2))) / 2.54
      let distMin // 投写距离Min
      let arc // 弧长
      let L // curveThrowDistance
      let R2L
      let curveLensshiftMin
      let curveLensshiftMax
      let lenshiftMax = this.selectedLensData.lcd.lensShiftRange.v.max * 100
      let increaseNum
      let lensshiftAmount
      let minCorrection

      // curveShape '0':垂直曲面, '1':水平曲面, '2': 平面
      // curveDirection '0':凹面, '1':凸面
      if (this.curveShape === '0' && this.curveDirection === '0') { // 凹面垂直
        curveLensshiftMin = this.selectedLensData.VConcaveMin
        curveLensshiftMin = curveLensshiftMin !== 0 ? curveLensshiftMin : this.selectedLensData.VConcaveMax
        curveLensshiftMax = this.selectedLensData.VConcaveMax
        distMin = this.$commonViewJs.calScreensizeToDistanceWide(curveScreenSize)
        let actualScreenH = this.getPointCurWidthAndHeight().height
        arc = this.curveRadius * (2 * Math.asin(actualScreenH / (2 * this.curveRadius)))
        // L = distMin - (this.curveRadius * (1 - Math.cos(2 * Math.asin(actualScreenH / (2 * this.curveRadius)) / 2)))
        L = distMin
        R2L = this.curveRadius / L
        increaseNum = (curveLensshiftMax - curveLensshiftMin) / lenshiftMax
        // lensshiftAmount = ((this.houseInfo.roomH - this.graph.pjZ) - (curveScreenW / 2)) / curveScreenW
        lensshiftAmount = Math.abs(this.vLensShiftNow)
        minCorrection = curveLensshiftMin + (lensshiftAmount * increaseNum)
      } else if (this.curveShape === '1' && this.curveDirection === '0') { // 凹面水平
        curveLensshiftMin = this.selectedLensData.HConcaveMin
        curveLensshiftMin = curveLensshiftMin !== 0 ? curveLensshiftMin : this.selectedLensData.HConcaveMax
        curveLensshiftMax = this.selectedLensData.HConcaveMax
        distMin = this.$commonViewJs.calScreensizeToDistanceWide(curveScreenSize)
        let actualScreenW = this.getPointCurWidthAndHeight().width
        arc = this.curveRadius * (2 * Math.asin(actualScreenW / (2 * this.curveRadius)))
        // L = distMin - (this.curveRadius * (1 - Math.cos(2 * Math.asin(actualScreenW / (2 * this.curveRadius)) / 2)))
        L = distMin
        R2L = this.curveRadius / L
        increaseNum = (curveLensshiftMax - curveLensshiftMin) / lenshiftMax
        // lensshiftAmount = ((this.houseInfo.roomH - this.graph.pjZ) - (curveScreenH / 2)) / curveScreenH
        lensshiftAmount = Math.abs(this.vLensShiftNow)
        minCorrection = curveLensshiftMin + (lensshiftAmount * increaseNum)
      } else if (this.curveShape === '0' && this.curveDirection === '1') { // 凸面垂直
        curveLensshiftMin = this.selectedLensData.VConvexMin
        curveLensshiftMin = curveLensshiftMin !== 0 ? curveLensshiftMin : this.selectedLensData.VConvexMax
        curveLensshiftMax = this.selectedLensData.VConvexMax
        distMin = this.$commonViewJs.calScreensizeToDistanceWide(curveScreenSize)
        let actualScreenH = this.getPointCurWidthAndHeight().height
        arc = this.curveRadius * (2 * Math.asin(actualScreenH / (2 * this.curveRadius)))
        L = distMin
        R2L = this.curveRadius / L
        increaseNum = (curveLensshiftMax - curveLensshiftMin) / lenshiftMax
        // lensshiftAmount = ((this.houseInfo.roomH - this.graph.pjZ) - (curveScreenW / 2)) / curveScreenW
        lensshiftAmount = Math.abs(this.vLensShiftNow)
        minCorrection = curveLensshiftMin + (lensshiftAmount * increaseNum)
      } else if (this.curveShape === '1' && this.curveDirection === '1') { // 凸面水平
        curveLensshiftMin = this.selectedLensData.HConvexMin
        curveLensshiftMin = curveLensshiftMin !== 0 ? curveLensshiftMin : this.selectedLensData.HConvexMax
        curveLensshiftMax = this.selectedLensData.HConvexMax
        distMin = this.$commonViewJs.calScreensizeToDistanceWide(curveScreenSize)
        let actualScreenW = this.getPointCurWidthAndHeight().width
        arc = this.curveRadius * (2 * Math.asin(actualScreenW / (2 * this.curveRadius)))
        L = distMin
        R2L = this.curveRadius / L
        increaseNum = (curveLensshiftMax - curveLensshiftMin) / lenshiftMax
        // lensshiftAmount = ((this.houseInfo.roomH - this.graph.pjZ) - (curveScreenH / 2)) / curveScreenH
        lensshiftAmount = Math.abs(this.vLensShiftNow)
        minCorrection = curveLensshiftMin + (lensshiftAmount * increaseNum)
      }
      if (R2L > minCorrection) {
        this.R_L_condition = true
        this.correctionResult = 'OK'
      } else {
        this.R_L_condition = false
        this.correctionResult = 'NG'
      }
      this.calcFocusResult(arc)
    },
    calcFocusResult (arc) {
      // let depthWide = F值 * PixelPitch * 0.0001*1.3* Math.pow((screensize / lcdSize), 2)
      let FNum = Number(this.selectedLensData.fNum.split('-')[0])
      let {PixelPitch, lcdSize} = this.selectedModelData
      let screenSize = Math.sqrt(Math.pow(this.graph.scrnW, 2) + Math.pow(this.graph.scrnH, 2)) / 2.54
      let depthWide = FNum * PixelPitch * 0.0001 * 1.3 * Math.pow((screenSize / lcdSize), 2)
      let depth = this.curveRadius * (1 - Math.cos((arc / this.curveRadius) / 2))
      // console.log(depthWide)
      // console.log(depth)
      if (depth < depthWide) {
        this.focusResult = 'OK'
      } else {
        this.focusResult = 'NG'
      }
    },
    // 获取x轴坐标在主墙上的最大值最小值，因为数据存在误差，判断当数据x最大时，取最大值的x为this.houseInfo.roomW的点(为曲面)
    getPointCurWidthAndHeight () {
      let initXMax, initXMin, initZMax, initZMin
      for (let i = 1; i < this.drawData.length; i++) {
        if (this.drawData[i].length > 0) {
          initXMax = this.drawData[i][0].x
          initXMin = this.drawData[i][0].x
          initZMax = this.drawData[i][0].z
          initZMin = this.drawData[i][0].z
          break
        }
      }

      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (this.drawData[i][j].x > initXMax) {
            initXMax = this.drawData[i][j].x
          }
          if (this.drawData[i][j].x < initXMin) {
            initXMin = this.drawData[i][j].x
          }
          if (this.drawData[i][j].z > initZMax) {
            initZMax = this.drawData[i][j].z
          }
          if (this.drawData[i][j].z < initZMin) {
            initZMin = this.drawData[i][j].z
          }
        }
      }
      let width = initXMax - initXMin
      let height = initZMax - initZMin
      return {
        width: width,
        height: height
      }
    },
    checkNGMsg () {
      this.correctionNGInfoArray = ['T_CURVE_CURVED_CORRECTION_MSG']
      // 投影位置が曲面の中心をずれた場合,文言：水平方向（のレンズシフト）をセンターにする
      if ((!this.isPJXYCenter || this.hLensShiftNow) && !this.correctionNGInfoArray.includes('T_CURVE_CURVED_CORRECTION_MSG5')) {
        this.correctionNGInfoArray.push('T_CURVE_CURVED_CORRECTION_MSG5')
      }
      // 設置角度が傾いた場合,文言：設置角度を０°にする
      if ((this.vAngle || this.hAngle) && !this.correctionNGInfoArray.includes('T_CURVE_CURVED_CORRECTION_MSG6')) {
        this.correctionNGInfoArray.push('T_CURVE_CURVED_CORRECTION_MSG6')
      }
      // R/Lが条件を満たさない場合,文言：スクリーン半径を大きくする 投写距離を長くする（レンズを変える）
      if (!this.R_L_condition && (!this.correctionNGInfoArray.includes('T_CURVE_CURVED_CORRECTION_MSG_3') && !this.correctionNGInfoArray.includes('T_CURVE_CURVED_CORRECTION_MSG_4'))) {
        this.correctionNGInfoArray.push('T_CURVE_CURVED_CORRECTION_MSG_3')
        this.correctionNGInfoArray.push('T_CURVE_CURVED_CORRECTION_MSG_4')
      }
      this.SET_CORRECTIONNGINFOMSG(this.correctionNGInfoArray)
      return this.correctionNGInfoArray
    },
    checkOkMsg () {
      this.SET_CORRECTIONNGINFOMSG([{'id': this.$t('T_RESULT_CAN_BE_CORRECTED')}])
      return [{'id': this.$t('T_RESULT_CAN_BE_CORRECTED')}]
    },
    checkIsProMsg () {
      this.SET_CORRECTIONNGINFOMSG(['T_MESSAGE_SURFACE_CORRECTION'])
      return ['T_MESSAGE_SURFACE_CORRECTION']
    },
    ...mapMutations(['SET_CORRECTIONNGINFOMSG'])
  },
  mounted () {
    this.calcCorrectionResult()
  }
}
</script>

<style type='text/css' scoped>
.result-tab{
  width: 780px;
  margin: 10px auto;
  /* height: 270px; */
}
.result-tab-pdf{
  width: 490px;
  margin: 10px auto;
}
.curve-result-info li:not(:first-of-type){
  padding-left: 10px;
}
</style>
<style>
.result-font-size{
  font-size: 12px !important;
  text-align: left;
  font-weight: 500;
  width: 500px;
}
.container-table-curved{
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 20vh; */
}
</style>



// WEBPACK FOOTER //
// src/view/result/curvedResultInformation.vue